module.exports = __webpack_public_path__ + "img/yellowAlert.78221690.svg";